export default __webpack_public_path__ + "static/media/Calculator.88488364.webm";